import { observable, action, makeObservable } from 'mobx';
import { MonthlyGoalFormState } from './MonthlyGoalFormState';
import { GoalsApi } from '../../../../apis/goals';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { MonthlyGoalIndex } from '../../../../types/goals';
import { routingStore } from '../../../../../common/stores/routing';
import { V3Routes } from '../../../../routes';
import { HomePageState } from '../../../../containers/home/states/HomePageState';

export class MonthlyGoalPaneState {
  homeState: HomePageState = null;
  formState: MonthlyGoalFormState = new MonthlyGoalFormState();
  submitting = false;
  submitted = false;
  month: string;
  monthlyGoals: RemoteResourceV3<MonthlyGoalIndex[]> = RemoteResourceV3.loading();

  constructor(homeState: HomePageState) {
    makeObservable(this, {
      formState: observable,
      submitting: observable,
      submitted: observable,
      month: observable,
      monthlyGoals: observable,
      selectMonth: action.bound,
      setFormValue: action.bound,
      submit: action.bound,
    });

    this.homeState = homeState;
  }

  init(year: number, month: number) {
    updateRemoteResourceV3(
      this.monthlyGoals,
      (v) => (this.monthlyGoals = v),
      () => GoalsApi.findAllMonthlyGoals()
    );
    this.formState.init(year, month);
    this.month = `${year}-${month}`;
  }

  async selectMonth(newValue) {
    this.month = newValue;
    const [year, month] = newValue.split('-').map((x) => parseInt(x));
    routingStore.push(V3Routes.monthlyGoal(year, month));
    this.formState.init(year, month);
  }

  async setFormValue(key, value) {
    this.formState.setValue(key, value);
    this.submitted = false;
  }

  async submit() {
    this.submitting = true;
    try {
      this.formState.clearErrors();
      try {
        const formData = this.formState.asJson();
        formData.todos = formData.todos.slice(0, formData.todos.length - 1);
        formData.next_actions = formData.next_actions.slice(0, formData.next_actions.length - 1);
        await GoalsApi.updateMonthlyGoal(formData);
        await this.homeState.monthlyGoals.init();
      } catch (error) {
        this.formState.setErrors(error.body);
      }
    } finally {
      this.submitting = false;
      this.submitted = true;
    }
  }
}
